module.exports = __webpack_public_path__ + "img/28.b1a5229f.png";